"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.form.title.edit': 'Edit Company',
    'company.form.title.add': 'Add Company',
    'company.form.back': 'Back',
    'company.form.name.label': 'Company Name',
    'company.form.name.placeholder': 'Enter company name',
    'company.form.nip.label': 'NIP',
    'company.form.nip.placeholder': '123-456-78-90',
    'company.form.email.label': 'E-mail',
    'company.form.email.placeholder': 'address@email.com',
    'company.form.phone.label': 'Phone',
    'company.form.phone.placeholder': '123 456 789',
    'company.form.address.label': 'Address',
    'company.form.street.placeholder': 'Street and number',
    'company.form.postal_code.placeholder': 'Postal code',
    'company.form.city.placeholder': 'City',
    'company.form.website.label': 'Website',
    'company.form.website.placeholder': 'https://company.com',
    'company.form.description.label': 'Description',
    'company.form.description.placeholder': 'Company description',
    'company.form.active.label': 'Active',
    'company.form.logo.label': 'Company Logo',
    'company.form.logo.placeholder': 'Select company logo',
    'company.form.submit.update': 'Update',
    'company.form.submit.create': 'Save',
    'company.form.submit.createCompanyData': 'Save Company Data',
    'company.form.acl.loadError': 'Failed to load ACL meta data:',
    'company.form.load.error': 'Failed to load company',
    'company.form.submit.updateError': 'Failed to update company',
    'company.form.submit.createError': 'Failed to create company',
    'company.form.submit.updateSuccess': 'Company updated successfully',
    'company.form.submit.createSuccess': 'Company created successfully',
};
